import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-menu-user-button-item',
  imports: [MatTooltip],
  templateUrl: './menu-user-button-item.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './menu-user-button-item.scss',
})
export class MenuUserButtonItem {
  tooltip = input('');
}
